import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _52e1aace = () => interopDefault(import('..\\pages\\advantage\\index.vue' /* webpackChunkName: "pages/advantage/index" */))
const _027ca72b = () => interopDefault(import('..\\pages\\apply\\index.vue' /* webpackChunkName: "pages/apply/index" */))
const _4700debe = () => interopDefault(import('..\\pages\\cooperation\\index.vue' /* webpackChunkName: "pages/cooperation/index" */))
const _2447d849 = () => interopDefault(import('..\\pages\\countryIntroduction\\index.vue' /* webpackChunkName: "pages/countryIntroduction/index" */))
const _00c816a8 = () => interopDefault(import('..\\pages\\hot\\index.vue' /* webpackChunkName: "pages/hot/index" */))
const _2936cbe8 = () => interopDefault(import('..\\pages\\news\\index.vue' /* webpackChunkName: "pages/news/index" */))
const _e508996c = () => interopDefault(import('..\\pages\\product\\index.vue' /* webpackChunkName: "pages/product/index" */))
const _3906cd10 = () => interopDefault(import('..\\pages\\studyTour\\index.vue' /* webpackChunkName: "pages/studyTour/index" */))
const _b9c16894 = () => interopDefault(import('..\\pages\\success\\index.vue' /* webpackChunkName: "pages/success/index" */))
const _f5c3dee6 = () => interopDefault(import('..\\pages\\university\\index.vue' /* webpackChunkName: "pages/university/index" */))
const _2b6f9ff0 = () => interopDefault(import('..\\pages\\user\\index.vue' /* webpackChunkName: "pages/user/index" */))
const _29fbe692 = () => interopDefault(import('..\\pages\\user\\index\\index.vue' /* webpackChunkName: "pages/user/index/index" */))
const _72c9e630 = () => interopDefault(import('..\\pages\\user\\index\\accommodation\\index.vue' /* webpackChunkName: "pages/user/index/accommodation/index" */))
const _64949116 = () => interopDefault(import('..\\pages\\user\\index\\account\\index.vue' /* webpackChunkName: "pages/user/index/account/index" */))
const _2be2bec3 = () => interopDefault(import('..\\pages\\user\\index\\appointment\\index.vue' /* webpackChunkName: "pages/user/index/appointment/index" */))
const _b04068ec = () => interopDefault(import('..\\pages\\user\\index\\download\\index.vue' /* webpackChunkName: "pages/user/index/download/index" */))
const _6c7d66ec = () => interopDefault(import('..\\pages\\user\\index\\faq\\index.vue' /* webpackChunkName: "pages/user/index/faq/index" */))
const _b7305426 = () => interopDefault(import('..\\pages\\user\\index\\service\\index.vue' /* webpackChunkName: "pages/user/index/service/index" */))
const _6a8cfbe2 = () => interopDefault(import('..\\pages\\user\\index\\application\\details.vue' /* webpackChunkName: "pages/user/index/application/details" */))
const _24d9aeb8 = () => interopDefault(import('..\\pages\\user\\index\\order\\details.vue' /* webpackChunkName: "pages/user/index/order/details" */))
const _3aff89ba = () => interopDefault(import('..\\pages\\visa\\index.vue' /* webpackChunkName: "pages/visa/index" */))
const _03a804c8 = () => interopDefault(import('..\\pages\\hot\\details.vue' /* webpackChunkName: "pages/hot/details" */))
const _2c6df5d8 = () => interopDefault(import('..\\pages\\news\\details.vue' /* webpackChunkName: "pages/news/details" */))
const _2b96a53d = () => interopDefault(import('..\\pages\\university\\details.vue' /* webpackChunkName: "pages/university/details" */))
const _2c5fbcdb = () => interopDefault(import('..\\pages\\index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/advantage",
    component: _52e1aace,
    name: "advantage"
  }, {
    path: "/apply",
    component: _027ca72b,
    name: "apply"
  }, {
    path: "/cooperation",
    component: _4700debe,
    name: "cooperation"
  }, {
    path: "/countryIntroduction",
    component: _2447d849,
    name: "countryIntroduction"
  }, {
    path: "/hot",
    component: _00c816a8,
    name: "hot"
  }, {
    path: "/news",
    component: _2936cbe8,
    name: "news"
  }, {
    path: "/product",
    component: _e508996c,
    name: "product"
  }, {
    path: "/studyTour",
    component: _3906cd10,
    name: "studyTour"
  }, {
    path: "/success",
    component: _b9c16894,
    name: "success"
  }, {
    path: "/university",
    component: _f5c3dee6,
    name: "university"
  }, {
    path: "/user",
    component: _2b6f9ff0,
    children: [{
      path: "",
      component: _29fbe692,
      name: "user-index"
    }, {
      path: "accommodation",
      component: _72c9e630,
      name: "user-index-accommodation"
    }, {
      path: "account",
      component: _64949116,
      name: "user-index-account"
    }, {
      path: "appointment",
      component: _2be2bec3,
      name: "user-index-appointment"
    }, {
      path: "download",
      component: _b04068ec,
      name: "user-index-download"
    }, {
      path: "faq",
      component: _6c7d66ec,
      name: "user-index-faq"
    }, {
      path: "service",
      component: _b7305426,
      name: "user-index-service"
    }, {
      path: "application/details",
      component: _6a8cfbe2,
      name: "user-index-application-details"
    }, {
      path: "order/details",
      component: _24d9aeb8,
      name: "user-index-order-details"
    }]
  }, {
    path: "/visa",
    component: _3aff89ba,
    name: "visa"
  }, {
    path: "/hot/details",
    component: _03a804c8,
    name: "hot-details"
  }, {
    path: "/news/details",
    component: _2c6df5d8,
    name: "news-details"
  }, {
    path: "/university/details",
    component: _2b96a53d,
    name: "university-details"
  }, {
    path: "/",
    component: _2c5fbcdb,
    name: "index"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
